import {mapKeys, isArray} from 'lodash'

export default function filterErrors (err) {
  let state = {message: {status: '', context: ''}, errors: {}}

  if (isArray(err)) {
    state.message = {status: 'danger', context: err[0]}
    return state
  }

  mapKeys(err, (value, key) => {
    if (key === '_errors') {
      state.message = {status: 'danger', context: value[0]}
    } else {
      state.errors[key] = value[0]
    }
  })
  return state
}



// WEBPACK FOOTER //
// ./src/utils/filterErrors.js